export default __webpack_public_path__ + "static/media/player_-1_eliminated.64276e9a.png";